export default "__VITE_ASSET__ebb08f99__"